<template>
<span v-if="show">
    <slot></slot>
</span>
</template>

<script>
import { mapState } from 'vuex'

export default {
    props: {
        for: {
            type: String,
            required: true,
            _descr: 'shows content for xs/s/m/l modes or its combination (s-sx)',
        },
    },
    computed: {
        ...mapState('dimensions', {
            dimensionsMode: 'mode',
        }),
        show () {
            return this.for.toLowerCase().split('-').indexOf(this.dimensionsMode) > -1
        },
    },
}
</script>
